const supplierCodesFormat = (itinerary) => {
  const codes = []
  for (let i = 0; i < itinerary.length; i++) {
    for (let ii = 0; ii < itinerary[i].data.length; ii++) {
      const supplierName = itinerary[i].data[ii].suppliername ? itinerary[i].data[ii].suppliername : itinerary[i].data[ii].operator
      if (itinerary[i].data[ii].suppliercode) {
        codes.push({
          supplierCode: itinerary[i].data[ii].suppliercode,
          supplierName: supplierName
        })
      } else if ((itinerary[i].data[ii].supplier)) {
        codes.push({
          supplierCode: itinerary[i].data[ii].supplier,
          supplierName: supplierName
        })
      }
    }
  }
  const uniqueCodes = [...new Map(codes.map(code => [code.supplierCode, code])).values()]

  return uniqueCodes
}

export { supplierCodesFormat }
